import { render, staticRenderFns } from "./FooterMobile.vue?vue&type=template&id=46176d56"
import script from "../script/footer.js?vue&type=script&lang=js&external"
export * from "../script/footer.js?vue&type=script&lang=js&external"
import style0 from "../less/footerMobile.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports